<p-blockUI [blocked]="blockui()" />
<div class="layout-topbar">
  <button
    #menubutton
    class="p-link layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <a
    class="layout-topbar-logo flex justify-center"
    [routerLink]="['/dashboard']"
  >
    <img
      src="assets/img/benz-cloud-logo-small.png"
      alt="Benz Cloud"
      class="w-8 mr-1"
    />
    <span class="mr-2">BENZ Cloud</span>
    @if (isDev) {
      <div class="bg-orange-500 text-sm text-white mr-2 p-2">Test-System</div>
    }
    @if (isOnline()) {
      <p-badge [value]="'Online'" severity="success" />
    } @else {
      <p-badge [value]="'Offline'" severity="danger" />
    }
  </a>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [class.layout-topbar-menu-mobile-active]="
      layoutService.profileSidebarVisible()
    "
  >
    <button
      class="p-link layout-topbar-button"
      (click)="layoutService.showConfigSidebar()"
      title="Design konfigurieren"
    >
      <i class="pi pi-palette"></i>
      <span>Design</span>
    </button>
    <p-button
      routerLink="/dashboard/profil"
      [rounded]="true"
      severity="secondary"
      icon="pi pi-user"
      [label]="adminName()"
    />
    <button class="p-link layout-topbar-button" (click)="processLogout()">
      <i class="pi pi-power-off"></i>
      <span>Abmelden</span>
    </button>
  </div>
</div>
